import { callPlanet } from './'

// type FetchAnalytics = ({ Country: string, Language: string }, string) => AjaxObservable
export const fetchAnalytics = ({ Country, Language }, partner) => (
  callPlanet(`Analytics/${Language}/${Country}/${partner}`)
)
